import { Component, OnInit, Input,  Inject, PLATFORM_ID, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { CustomDeviceDetectorService } from '../../services/CustomDeviceDetectorService';
import { isPlatformServer } from '@angular/common';
import Swiper from 'swiper';

@Component({
  selector: 'app-documentation-module',
  templateUrl: './documentation-module.component.html',
})
export class DocumentationModuleComponent implements OnInit, AfterViewInit {
  @Input() rendering: ComponentRendering;
  @ViewChild('DocumentationModuleSlider', { static : false}) swiperSlider!: ElementRef;
  jssStylingService: JssStylingService;
  dynamicClass: string;
  devicedetectorService: CustomDeviceDetectorService;
  isMobile: boolean;
  swiper: Swiper;
  _isPlatformServer: boolean = false;
  //public cards: IDocumentation[] = [];
  public cards: any[] = [];
  showMoreBtn: boolean = false;

  constructor(jssStylingService: JssStylingService,
    devicedetectorService: CustomDeviceDetectorService,
    @Inject(PLATFORM_ID) public readonly platformId: string,
    ) { 
    this.jssStylingService = jssStylingService;
    this.devicedetectorService = devicedetectorService;
    platformId 
  }

  ngOnInit() {
    this._isPlatformServer = isPlatformServer(this.platformId);
    // remove this after implementation is done
    console.log('DocumentationModule component initialized with component data', this.rendering);
  
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    this.isMobile = this.devicedetectorService.isMobile();
    let loopLength = (this.rendering.fields?.PageSize as any).value ? (this.rendering.fields?.PageSize as any).value : 6;
    if((this.rendering.fields.Cards as any)?.length > 0){
      for (let i = 0; i < loopLength; i++) {
        this.cards.push((this.rendering.fields.Cards as any)[i]);
        //this.cards.push(this.fillCards((this.rendering.fields.Cards as any)[i]?.fields));
      }
      this.showMoreBtn = (this.rendering.fields.Cards as any)?.length > this.cards.length
    }
  }

  showMore() {
    let loopLength =
      (this.rendering?.fields?.PageSize as any)?.value > 0
      ? (this.rendering?.fields?.PageSize as any)?.value + this.cards.length
      : 6 + this.cards.length;
    for (let i = this.cards.length; i < loopLength; i++) {
      if ((this.rendering.fields.Cards as any)[i]) {
        this.cards.push((this.rendering.fields.Cards as any)[i]);
        //this.cards.push(this.fillCards((this.rendering.fields.Cards as any)[i]?.fields));
      } else {
        break;
      }
    }
    this.showMoreBtn = (this.rendering.fields.Cards as any)?.length > this.cards.length;
  }

  fillCards(input: any):IDocumentation {
    return {
      Title: input?.Title?.value,
      Description: input?.Description?.value,
      Link: input?.Link.value,
      Type: input?.Type.value.toLowerCase(),
      FileHref: input?.File?.value?.src,
      FileText: input?.File?.value?.name,
      FileExtension: input?.File?.value?.extension,
    };
  }

  ngAfterViewInit() {
    const _this = this;
    if(!this._isPlatformServer && this.isMobile){
      this.swiper = new Swiper(this.swiperSlider.nativeElement, {
        spaceBetween: 21,
        freeMode: true,
        grabCursor: true,
        centeredSlides: false,
        slidesPerView: 'auto',
        on: {
          activeIndexChange: function() {
            if(_this.swiper.activeIndex == _this.cards.length - 2){
              _this.showMore();
              setTimeout(()=>{
                _this.swiper.update();
              },10)
            }
          }
        }
      });
    }
  }
}


interface IDocumentation {
  Title: string;
  Description: string;
  Type: string;
  Link?: string;
  FileHref?: string;
  FileText?: string;
  FileExtension?: string;
}